<template>
    <div class="head">
        <div class="logo">
            <div>
                <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/logo_1_1.png" class="logo_1">
                <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/logo_3_1.png" class="logo_3">
            </div>
            <div>
                <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/logo_2_1.png" class="logo_2">
            </div>
        </div>
        <div class="kv">
            <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/kv.png">
        </div>
    </div>
</template>

<script>
    export default {
        name: "banner"
    }
</script>

<style scoped lang="scss">
    .head .logo{
        width: 100%;
        display: flex;
        flex-flow: row;
        justify-content: space-between;
        margin: 10px 0;
        .logo_1{
            width: 25px;
            height: 25px;
            margin-left: 20px;
        }
        .logo_2{
            width: 75px;
            height: 25px;
            margin-right: 20px;
        }
        .logo_3{
            width: 25px;
            height: 25px;
            margin-left: 5px;
        }
    }
    .kv{
        width: 100%;
        height: 175px;
        display: flex;
        justify-content: center;
        img{
            width: 275px;
            height: 157px;
            object-fit: cover;
        }
    }
</style>